import styled from 'styled-components'

const TV = styled.span<{ $negative?: boolean }>`
  color: ${(p) =>
    p.$negative ? p.theme.uiKit.colors.theme.negative.main : p.theme.uiKit.colors.global.general.secondary};
`

export const reportPercents = (v: string) => {
  if (!v) {
    return null
  }
  if (v === '-1.00') {
    return 'N/A'
  }

  return v.startsWith('-') ? <TV $negative>({v})%</TV> : <TV>{v}%</TV>
}
